import { unpackRules } from '@casl/ability/extra';
import {
  AbilityInterface,
  IAuthUser,
  IGroup,
  IPreferences,
  IRole,
  PackedAbilities,
} from '@kinet-open-network/shared/data-access/model';
export class AuthenticatedUser implements IAuthUser {
  id!: string;
  name!: string;
  surname?: string;
  fullName!: string;
  email!: string;
  preferences: IPreferences = {};
  groupId!: string;
  roles!: IRole[];
  group!: IGroup;
  abilities: AbilityInterface['rules'] = [];
  twoFactorEnabled!: boolean;
  options!: Record<string, any>;

  constructor(data: Partial<AuthenticatedUser>) {
    Object.assign(this, data);
  }

  static fromResponse(data: IAuthUser & { abilities: PackedAbilities }) {
    return new AuthenticatedUser({
      ...data,
      abilities: unpackRules(data.abilities),
    });
  }

  get belongsToMasterGroup() {
    return this.group?.master === true;
  }
}
